import { forwardRef, useState } from 'react'

import { v4 as uuidv4 } from 'uuid'

import FormControl from '../FormControl/FormControl'
import { FormControlProps } from '../FormControl/util'

import InputBase, { InputBaseProps } from './InputBase'

type Props = InputBaseProps & FormControlProps
const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      ariaLabel,
      autoFocus,
      caption,
      className,
      errorMessage,
      id: propId,
      isClearable,
      isDisabled,
      isInvalid,
      isLoading,
      isReadOnly,
      isRequired,
      label,
      tooltip,
      type,
      leftAddon,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      onValueChange,
      placeholder,
      prefix,
      prefixIcon,
      rightAddon,
      size,
      suffix,
      suffixIcon,
      textAlign,
      value,
      width = '100%',
    },
    ref
  ) => {
    const [id] = useState(propId ?? uuidv4())
    return (
      <FormControl
        caption={caption}
        errorMessage={errorMessage}
        id={id}
        isInvalid={isInvalid}
        isRequired={isRequired}
        label={label}
        tooltip={tooltip}
        width={width}
      >
        {({ ariaDescribedBy, ariaInvalid, ariaLive }) => (
          <InputBase
            ariaDescribedBy={ariaDescribedBy}
            ariaInvalid={ariaInvalid}
            ariaLabel={ariaLabel}
            ariaLive={ariaLive}
            autoFocus={autoFocus}
            className={className}
            id={id}
            isClearable={isClearable}
            isDisabled={isDisabled}
            isInvalid={isInvalid}
            isLoading={isLoading}
            isReadOnly={isReadOnly}
            isRequired={isRequired}
            leftAddon={leftAddon}
            onBlur={onBlur}
            onClick={onClick}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            onValueChange={onValueChange}
            placeholder={placeholder}
            prefix={prefix}
            prefixIcon={prefixIcon}
            ref={ref}
            rightAddon={rightAddon}
            size={size}
            suffix={suffix}
            suffixIcon={suffixIcon}
            textAlign={textAlign}
            type={type}
            value={value}
            width="100%"
          />
        )}
      </FormControl>
    )
  }
)

export default Input
